import FormattedMessage from 'I18n/components/FormattedMessage';
import unescapedText from 'I18n/utils/unescapedText';
import { formatHtml } from 'sanitize-text/sanitizers/HtmlSanitizer';
import { getTextContentFromHtml } from 'sanitize-text/sanitizers/TextSanitizer';
import styled from 'styled-components';
import SVGAttach from 'visitor-ui-component-library-icons/icons/SVGAttach';
import VizExIcon from 'visitor-ui-component-library/icon/VizExIcon';
import UnreadCountBadge from 'conversations-visitor-experience-components/visitor-widget/spotlight/UnreadCountBadge';
import SpotlightPopupCard, { PopupBodyText } from '../popup-card/SpotlightPopupCard';
import SpotlightPopupHeader from '../popup-card/SpotlightPopupHeader';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PreviewText = styled(PopupBodyText).withConfig({
  displayName: "NewMessagePreviewPopup__PreviewText"
})(["display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;"]);
const NewMessagePreviewPopup = ({
  agentName,
  agentJobTitle,
  agentAvatarUrl,
  isBot,
  isResponderAI,
  isOnline,
  isDismissing,
  hasAttachment,
  messagePreviewText,
  unreadCount,
  width,
  onDismiss,
  onDismissAnimationEnd,
  onOpen
}) => /*#__PURE__*/_jsx(SpotlightPopupCard, {
  width: width,
  isDismissing: isDismissing,
  ariaLabel: unescapedText('conversations-visitor-ui.spotlight.newMessagePreviewPopup.dialogLabel', {
    agentName
  }),
  dismissAriaLabel: unescapedText('conversations-visitor-ui.spotlight.newMessagePreviewPopup.dismiss'),
  testId: "spotlight-new-message-preview-popup",
  onDismiss: onDismiss,
  onDismissAnimationEnd: onDismissAnimationEnd,
  onOpen: onOpen,
  announcementText: hasAttachment ? getTextContentFromHtml(messagePreviewText) || unescapedText('conversations-visitor-ui.attachments.threadPreview') : getTextContentFromHtml(messagePreviewText),
  badge: /*#__PURE__*/_jsx(UnreadCountBadge, {
    count: unreadCount
  }),
  children: /*#__PURE__*/_jsx(SpotlightPopupHeader, {
    avatarUrl: agentAvatarUrl,
    avatarName: agentName,
    isBot: isBot,
    isResponderAI: isResponderAI,
    isOnline: isOnline,
    showStatus: true,
    nameLine: agentJobTitle !== null && agentJobTitle !== void 0 ? agentJobTitle : agentName,
    children: hasAttachment ? /*#__PURE__*/_jsxs(PreviewText, {
      children: [/*#__PURE__*/_jsx(VizExIcon, {
        className: "m-right-2",
        icon: /*#__PURE__*/_jsx(SVGAttach, {})
      }), getTextContentFromHtml(messagePreviewText) || /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-visitor-ui.attachments.threadPreview"
      })]
    }) : /*#__PURE__*/_jsx(PreviewText, {
      dangerouslySetInnerHTML: {
        __html: formatHtml(messagePreviewText)
      }
    })
  })
});
NewMessagePreviewPopup.displayName = 'NewMessagePreviewPopup';
export default NewMessagePreviewPopup;